module.exports = __webpack_public_path__ + "media/src/assets/images/lps-family-f9c338e188f7d4a3401aa18e0d074ebc.png";